module.exports = __webpack_public_path__ + "static/media/f1.dd6d931a.jpg";